import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, headerBuilder } from '../http';
export var fetchLocales = function fetchLocales() {
  return axios.get("".concat(bundle.apiLocation(), "/meta/locales"));
};
export var fetchTimezones = function fetchTimezones() {
  return axios.get("".concat(bundle.apiLocation(), "/meta/timezones"));
};
export var fetchSpaceWebhookEvents = function fetchSpaceWebhookEvents() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get("".concat(bundle.apiLocation(), "/meta/webhooks/events/space"), {
    headers: headerBuilder(options)
  }).then(function (response) {
    return response.data;
  })["catch"](handleErrors);
};
export var fetchKappWebhookEvents = function fetchKappWebhookEvents() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get("".concat(bundle.apiLocation(), "/meta/webhooks/events/kapp"), {
    headers: headerBuilder(options)
  }).then(function (response) {
    return response.data;
  })["catch"](handleErrors);
};
export var fetchSpaMeta = function fetchSpaMeta() {
  return axios.get("".concat(bundle.apiLocation(), "/meta/spa"), {
    __bypassInitInterceptor: true,
    headers: {
      'X-Kinetic-ForcePreflight': 'ice-cream-cone'
    }
  }).then(function (response) {
    return response.data;
  })["catch"](handleErrors);
};